import {Box} from '@mantine/core';
import {type PropsWithChildren, useEffect} from 'react';
import {GoogleAdBannerName} from '../../../config/constants/googleAdBanner';
import isAppWebView from '../../../config/isAppWebView';
import {useAuth} from '../../../core/usecases/useAuth';
import {GoogleAdBanner} from '../../../shared/components/Banner/GoogleAdBanner';
import {GeneralFooter} from '../../../shared/components/Footer/general';
import {GeneralHeaderContainer} from '../../../shared/components/Header/General/container';
import {EventListPageBanner} from '../../../shared/components/Sidebar/EventListPageBanner';
import {PcCommunityTopicsHeadline} from '../../../shared/components/Sidebar/PcCommunityTopicsHeadline';
import {SignUp} from '../../../shared/components/Sidebar/SignUp';
import {useGoogleAdBanner} from '../../../shared/services/useGoogleAdBanner';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

export const ColumnLayout = ({children}: PropsWithChildren) => {
  const {isSignedIn} = useAuth();
  const {isPC} = useMediaQuery();

  // DFPバナーのセット
  const googleAdBannerNames = [
    GoogleAdBannerName.B_RECTANGLE,
    GoogleAdBannerName.B_RECTANGLE_BOTTOM,
  ];
  const {setShouldRefetch} = useGoogleAdBanner(googleAdBannerNames);

  useEffect(() => {
    setShouldRefetch(true);
  }, []);

  return (
    <>
      <div>
        {!isAppWebView() && <GeneralHeaderContainer />}
        <main>
          <Box className="flex min-h-screen flex-col items-center bg-background-1 py-12 pc:py-32">
            <div className="flex items-start">
              {/* 左・中央カラム */}
              <div className="w-full pc:w-[880px]">{children}</div>
              {/* 右カラム */}
              {isPC && (
                <Box className="w-[300px] ml-20 sticky top-[150px] flex flex-col gap-y-8">
                  <GoogleAdBanner
                    googleAdBannerName={GoogleAdBannerName.B_RECTANGLE}
                  />
                  <PcCommunityTopicsHeadline />
                  {!isSignedIn && <SignUp />}
                  <EventListPageBanner />
                  <GoogleAdBanner
                    googleAdBannerName={GoogleAdBannerName.B_RECTANGLE_BOTTOM}
                  />
                </Box>
              )}
            </div>
          </Box>
        </main>
        {!isAppWebView() && <GeneralFooter />}
      </div>
    </>
  );
};
